import { useEffect, useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { FileText, Image as ImageIcon, Inbox, LayoutDashboard, LogOut, Menu, Settings as SettingsIcon, Users, X, ExternalLink } from "lucide-react";
import { adminApi } from "./api";
import { IMG } from "../../data/content";

const NAV_ITEMS = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/content", label: "Content Editor", icon: FileText },
  { to: "/admin/team-services", label: "Team & Services", icon: Users },
  { to: "/admin/submissions", label: "Contact Submissions", icon: Inbox },
  { to: "/admin/media", label: "Media Manager", icon: ImageIcon },
  { to: "/admin/settings", label: "Settings", icon: SettingsIcon },
];

export default function AdminLayout() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [navOpen, setNavOpen] = useState(false);

  useEffect(() => {
    adminApi.get("/auth/me").then((r) => setUser(r.data)).catch(() => navigate("/admin/login"));
  }, [navigate]);

  const logout = async () => {
    try { await adminApi.post("/auth/logout"); } finally { navigate("/admin/login"); }
  };

  if (!user) return <div className="admin-shell"><p className="admin-loading" data-testid="admin-loading">Checking session…</p></div>;

  return (
    <div className="admin-shell" data-testid="admin-shell">
      <header className="admin-topbar">
        <button className="admin-nav-toggle" onClick={() => setNavOpen(!navOpen)} aria-label="Toggle admin navigation" data-testid="admin-nav-toggle">
          {navOpen ? <X size={20} /> : <Menu size={20} />}
        </button>
        <img src={IMG.logo} alt="Dishan International Group" />
        <span className="admin-topbar-title">Admin Panel</span>
        <span className="admin-topbar-user" data-testid="admin-user-email">{user.email}</span>
      </header>
      <div className="admin-body">
        <aside className={`admin-sidebar${navOpen ? " open" : ""}`}>
          <nav aria-label="Admin">
            {NAV_ITEMS.map((item) => (
              <NavLink
                key={item.to} to={item.to} end={item.end}
                onClick={() => setNavOpen(false)}
                className={({ isActive }) => `admin-nav-link${isActive ? " active" : ""}`}
                data-testid={`admin-nav-${item.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              >
                <item.icon size={17} /> {item.label}
              </NavLink>
            ))}
          </nav>
          <div className="admin-sidebar-foot">
            <a href="/" target="_blank" rel="noreferrer" className="admin-nav-link" data-testid="admin-view-site-link"><ExternalLink size={17} /> View site</a>
            <button className="admin-nav-link logout" onClick={logout} data-testid="admin-logout-button"><LogOut size={17} /> Logout</button>
          </div>
        </aside>
        <main className="admin-main">
          <Outlet context={{ user }} />
        </main>
      </div>
    </div>
  );
}
